// removed by extract-text-webpack-plugin
module.exports = {"main":"_1U329sndLg-ZuhNxOrke2K","logo":"_2mwxikvScNOelzru5bk5eL"};


//////////////////
// WEBPACK FOOTER
// ./components/LoggedOutHeader.module.css
// module id = 2358
// module chunks = 1